// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"109":"63e202a6","247":"35504f7b"}[chunkId] + ".chunk.js";
};